// Route guard: renders children only when authenticated; otherwise redirects to /login
// (preserving the intended path so login can return the user there).

import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Loading } from "@/components/States";

export function RequireAuth({ children }: { children: ReactNode }) {
  const { status } = useAuth();
  const location = useLocation();

  if (status === "loading") {
    return (
      <div data-slot="boot-screen" className="grid min-h-dvh place-items-center bg-surface-0 px-4">
        <Loading label="Menyiapkan sesi…" />
      </div>
    );
  }

  if (status === "anonymous") {
    const returnTo = location.pathname + location.search;
    return <Navigate to="/login" replace state={{ returnTo }} />;
  }

  return <>{children}</>;
}
